<script lang="ts" setup>
	import type { ClassNameValue } from 'tailwind-merge'
	import type { FormRecordsContext } from '@/composables/useFormsFields'

	defineProps<{
		items: Record<string, FormRecordsContext>
		itemCls?: ClassNameValue
		inputCls?: ClassNameValue
		tag?: string
	}>()
	const form = defineModel<RecordSchema>({ required: true })
	const cls = computed(() => String(useAttrs().class))
	defineOptions({
		inheritAttrs: false
	})
	const filterKey = (item: FormRecordsContext) => {
		const { hidden, ...rest } = item
		return rest
	}
</script>
<template>
	<component :is="tag || 'div'" :class="cls">
		<template v-for="(item, index) in items" :key="`form-item-${String(index)}`">
			<template v-if="item && !item?.hidden">
				<li v-if="tag === 'ul'" :class="itemCls">
					<slot v-bind="item">
						<forms-field-list
							v-bind="filterKey(item)"
							v-model:value="form[item.form_name]"
							:wrapper-class="item?.wrapperClass"
							:input-class="[inputCls, item.inputClass]"
						>
							<template #[item.form_name]>
								<slot :name="item.form_name" v-bind="item"> </slot>
							</template>
							<template v-if="$slots.label" #label="scope">
								<slot name="label" v-bind="scope" />
							</template>
						</forms-field-list>
					</slot>
				</li>
				<template v-else>
					<slot v-bind="item">
						<forms-field-list
							v-bind="filterKey(item)"
							v-model:value="form[item.form_name]"
							:wrapper-class="[item?.wrapperClass, itemCls]"
							:input-class="[inputCls, item.inputClass]"
						>
							<template #[item.form_name]>
								<slot :name="item.form_name" v-bind="item"> </slot>
							</template>
							<template #label="scope" v-if="$slots.label">
								<slot name="label" v-bind="scope" />
							</template>
						</forms-field-list>
					</slot>
				</template>
			</template>
		</template>
	</component>
</template>
